/**
 * Builds a Shopware WebP thumbnail URL matching SharedImage.getModifiedSrcSet.
 */
export function buildWebpThumbnailUrl(url: string, size: string): string {
  if (!url) return "";

  const modifiedUrl = url.replace("/media/", "/thumbnail/");
  const match = modifiedUrl.match(/(.+)\.([a-zA-Z0-9]+)(\?.*)?$/);

  if (!match) return url;

  const [, base, , query] = match;
  return `${base}_${size}.webp${query || ""}`;
}
